import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export type Brand = {
  id: number;
  name: string;
  logo_url: string;
};

type BrandContextType = {
  brands: Brand[];
  addBrand: (brand: Brand) => void;
  deleteBrand: (id: number) => void;
  refreshBrands: () => void;
};

const BrandContext = createContext<BrandContextType | undefined>(undefined);

export const BrandProvider = ({ children }: { children: React.ReactNode }) => {
  const [brands, setBrands] = useState<Brand[]>([]);

  const fetchBrands = async () => {
    const { data, error } = await supabase.from("Brand").select("*");
    if (error) {
      console.error("❌ Failed to fetch brands:", error.message);
    } else if (data) {
      setBrands(data);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  const addBrand = (brand: Brand) => {
    setBrands((prev) => [...prev, brand]);
  };

  const deleteBrand = (id: number) => {
    setBrands((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <BrandContext.Provider value={{ brands, addBrand, deleteBrand, refreshBrands: fetchBrands }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrandContext = () => {
  const context = useContext(BrandContext);
  if (!context) throw new Error("useBrandContext must be used within BrandProvider");
  return context;
};
